import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

export const useClaimAssets = () => {
    const { ids = [], isVisible } = useSelector((state: Store) => ({
        ids: state.supplies.fund.ids,
        isVisible: state.supplies.fund.isVisible,
    }));

    return { ids, isVisible };
};
